/* eslint-disable react/require-default-props */
/* eslint-disable camelcase */
// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================

// ==================Style&IMG===================
import { useEffect } from 'react';
import './style.scss';
import { useParams } from 'react-router-dom';

function NotFound() {
  const slug = useParams();
  useEffect(() => {
    if (slug.typeInfo !== 'DOI' && slug.typeInfo !== 'description' && slug.typeInfo !== 'instrumentation' && slug.typeInfo !== 'collocation' && slug.typeInfo !== 'associated' && slug.typeInfo !== 'data' && slug.typeInfo !== 'quality') {
      if (document.getElementsByClassName('app-404').length !== 0) {
        window.location.reload();
      }
    }
  });
  return (
    <>
      <div className="metatitle"><span>Check last element of URL</span></div>
      <div>
        <p>
          The URL's not good, please verify the
          last element of the URL and replace it,
          or click on one item in the left menu to complete th request
        </p>
      </div>
    </>
  );
}

export default NotFound;
